import { Card, Chip } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Row } from 'global/components/row';

export const StyledHeadContainer = styled(Row)(({ theme }) => ({
  marginBottom: theme.spacing(2),
}));

export const StyledChip = styled(Chip)(({ theme }) => ({
  position: 'absolute',
  top: theme.spacing(1),
  left: theme.spacing(1),
}));

export const StyledCard = styled(Card, {
  shouldForwardProp: (prop) => prop !== 'fullHeight',
})(({ theme, fullHeight }) => ({
  marginRight: theme.spacing(1),
  position: 'relative',
  overflow: 'hidden',
  ...(fullHeight ? { height: '100%' } : {}),

  '& .MuiChip-root': {
    backgroundColor: theme.palette.background.paper,
    fontStyle: 'italic',

    '& .MuiIcon-root': {
      fontSize: 18,
    },
  },
}));

export const StyledTitleText = styled('div')({
  width: '100%',
  overflowX: 'scroll',
  wrap: 'nowrap',
});

export const StyledFlex = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
});
